import { SupportedLocales } from 'client/i18n/types';

import { QuotesEn } from './en';
import { QuotesLA } from './es-LA';
import { QuotesId } from './id';
import { QuotesBR } from './pt-BR';

type LocalizedQuotesMap = {
  [key in SupportedLocales]?: () => JSX.Element;
};

export const localizedQuotesMap: LocalizedQuotesMap = {
  en: QuotesEn,
  'es-LA': QuotesLA,
  id: QuotesId,
  'pt-BR': QuotesBR,
};
